<template>
  <el-button
    v-outFocus
    @mouseenter.native="handleMouseEnter"
    @mouseleave.native="handleMouseLeave"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <svg-icon
      v-show="!ifHover"
      class-name="icon-class"
      :icon-class="svgIconClass"
    />
    <svg-icon
      v-show="ifHover"
      class-name="icon-class"
      :icon-class="svgIconClassHover"
    />
  </el-button>
</template>

<script>
export default {
  props: {
    svgIconClass: {
      type: String,
      default: '',
    },
    svgIconClassHover: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ifHover: false,
    }
  },
  methods: {
    handleMouseEnter() {
      this.ifHover = true
    },
    handleMouseLeave() {
      this.ifHover = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
